import { GET_APPOINTMENT_LENGTH } from "../actions/patientAction"

const filterAppointmentReducer = (state = [], { type,  data = [] }) => {
    switch (type) {
      case GET_APPOINTMENT_LENGTH:
        return data
      default:
        return state
    }
}
  
  export default filterAppointmentReducer